import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/settings/registrars/template/template-loading';

export const Route = createFileRoute('/_private/settings/registrars/_template')({
  pendingComponent: TemplateLoading,
});
